<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="基本信息" name="baseInfo">
        <div class="user-form">
          <form class="form-horizontal form-w8 form-c200">
            <div  style="width: 0px;height: 0px;overflow: hidden;"><!--这里主要解决自动填充账号密码的问题，谷歌下特烦恼，所以勇哥影藏的输入框填充起来-->
              <input type="password" name="password">
              <input type="text" name="email">
              <input type="text" name="account"/>
              <input type="text" name="phone"/>
            </div>
            <div class="form-group" :class="{'has-error':errors.has('name')}">
              <label class="control-label"><span class="required">*</span>姓名：</label>
              <div class="controls">
                <input name="name" v-validate="rules.name" class="form-control" type="text"
                       v-model="model.name">
                <span v-show="errors.has('name')" class="error-message">{{ errors.first('name') }}</span>
              </div>
            </div>
            <div class="form-group">
              <label class="control-label">账号：</label>
              <div class="controls">
                <input name="phone" class="form-control" type="text" readonly="readonly"
                       v-model="model.account">
              </div>
            </div>
            <div class="form-group">
              <label class="control-label">密码：</label>
              <div class="controls">
                <input name="phone" class="form-control" type="password"
                       v-model="model.password">
              </div>
            </div>
            <div class="form-group">
              <label class="control-label">手机号码：</label>
              <div class="controls">
                <input name="phone" class="form-control" type="text" readonly="readonly"
                       v-model="model.phone">
              </div>
            </div>
            <div class="form-group" :class="{'has-error':errors.has('email')}">
              <label class="control-label">Email：</label>
              <div class="controls">
                <input name="email" v-validate="rules.email" class="form-control" type="text"
                       v-model="model.email">
                <span v-show="errors.has('email')" class="error-message">{{ errors.first('email') }}</span>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label">职位：</label>
              <div class="controls">
                <input name="position" v-validate="rules.position" class="form-control" type="text" readonly="readonly"
                       v-model="model.position">

              </div>
            </div>
            <div class="form-group">
              <label class="control-label"></label>
              <div class="controls form-op">
                <button type="button" class="btn btn-primary" @click="onSubmit">
                  确定
                </button>
                <button type="button" class="btn btn-default" @click="onCancel">取消</button>
              </div>
            </div>
          </form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="其他信息" name="othersInfo">
        <div class="user-form">
          <form class="form-horizontal form-w8 form-c200">
            <div class="form-group">
              <label class="control-label">所在部门：</label>
              <div class="controls">
                <input class="form-control" type="text" v-model="model.deptName" readonly="readonly"/>
              </div>
            </div>
            <div class="form-group">
              <label class="control-label">角色：</label>
              <div class="controls">
                <input class="form-control" type="text" v-model="model.roleNames" readonly="readonly"/>
              </div>
            </div>
            <div class="form-group">
              <label class="control-label">管辖范围：</label>
              <div class="controls">
                <textarea rows="3" cols="50" class="form-control" v-model="model.deptNames"
                          readonly="readonly"></textarea>
              </div>
            </div>
          </form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="功能权限查看" name="featureShow">
        <FeatureShow :userId="model.id" ref="featureShow"></FeatureShow>
      </el-tab-pane>

    </el-tabs>
  </div>

</template>
<style lang="scss" rel="stylesheet/scss" scoped>
  .el-dialog__body {
    padding-top: 0px;
  }

</style>
<script type="text/ecmascript-6">
  import {Tree, Tabs, TabPane} from 'element-ui';
  import FeatureShow from './FeatureShow'
  import mixin from '../../mixin';

  export default {
    mixins: [mixin],
    components: {
      'el-tree': Tree, 'el-tabs': Tabs, 'el-tab-pane': TabPane, FeatureShow,
    },
    props: {
      value: Object
    },
    data() {
      //必须要有这些字段, vue的双向绑定才不会有问题
      let model = Object.assign({
        id: '',
        name: '',
        phone: '',
        email: '',
        deptId: '',
        deptName: '',
        position: '',
        roleIds: '',
        roleNames: '',
        deptIds: '',
        deptNames: '',
        orderNum: ''
      }, this.value || {});

      return {
        model,
        activeName: 'baseInfo',
        deptTree: [],
        deptList: [],
        popDept: false,
        rules: this.defaultRule(model)
      }
    },
    mounted() {
      this.initialize()
    },
    methods: {
      initialize() {
        this.$http
          .get('/api/user/myInfo')
          .then(({data}) => {
            if (data.success) {
              this.model = data.data;
            } else {
              this.$layer.alert("用户不存在");
            }
          });
      },
      onSubmit() {
        this.$validator.validateAll().then((result) => {
          if (!result) {
            return;
          }
          this.$http
            .post('/api/user/updateMyInfo', this.model)
            .then(({data}) => {
              if (data.success) {
                //赋予id是预防dialog没能关闭, 再次点击保存导致重复
                this.$layer.success('保存成功');
                this.$emit('close');
              } else {
                this.$layer.alert(data.errorMsg)
              }

            })
        });
      },
      onCancel() {
        this.$emit('close');
      },
      handleClick(item) {
        if (this.model.id && item.name == "featureShow") {
          let ref = item.name;
          this.$refs[ref].init();
        }


      }
    },
    computed: {
      isModify() {
        return this.model.id;
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/modules/user/components/MyInfo.vue